/**
 * Type d'une {@link Resource}.
 * @abstract
 * @public
 */
export enum ResourceType /** L'ordre dans l'enum influe sur l'ordre d'apparition */ {
	Dossier = 'privateFolder',
	Partage = 'sharedFolder',
	Public = 'commonFolder',
	Recent = 'recentlyOpenedResourcesFolder',
	Favori = 'favoriteFolder',
	Corbeille = 'trashFolder',
	Lot = 'bundle',
	Document = 'document',
	Shortcut = 'shortcut',
	Contract = 'contract',
	ReferenceContract = 'referenceContract',
	AnalysisDataset = 'analysisDataset',
}
